import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SectionValuesModule} from '../section-values/section-values.module';
import {SectionTestimonialsComponent} from "./testimonials/section-testimonials.component";
// Removed ng-bootstrap - using pure CSS carousel instead


@NgModule({
  declarations: [
    SectionTestimonialsComponent
  ],
  imports: [
    CommonModule
    // NgbCarouselModule removed
  ],
})
export class SectionTestimonialsModule {
}
